/*
 * @Description: 数据统计
 * @Author: gao shuai
 * @Date: 2020-04-30 16:50:09
 * @LastEditTime: 2020-06-19 16:45:41
 * @LastEditors: gao shuai
 */

import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  // 商户列表
  async merchantlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageStatistics/GetTenantStatisticsPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 代理列表
  async agentlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageStatistics/GetAgentStatisticsPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 分区列表
  async arealist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageStatistics/GetPartitionStatisticsPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 发布站统计
  async publishStatic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageStatistics/GetPublishStatisticsPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }
};
